﻿import {ErrorBundle, errorToErrorBundle} from "@2d-front-monorepo/core";
import {JSX} from "react";
import Message from "../HtmlControls/Message";

export default function ErrorMessage({error}: { error: Error | ErrorBundle }): JSX.Element {
	let bundle: ErrorBundle;
	if (error instanceof Error) {
		bundle = errorToErrorBundle(error);
	} else {
		bundle = error;
	}

	return <Message title={bundle.title}
	                detail={bundle.detail}
	                items={bundle.errors}
	                footer={bundle.footer}
	                type="error"/>;
}
